import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import de from './locales/de.json';
import en from './locales/en.json';
import fr from './locales/fr.json';
import es from './locales/es.json';
import it from './locales/it.json';
import pt from './locales/pt.json';
import nl from './locales/nl.json';
import pl from './locales/pl.json';
import cs from './locales/cs.json';
import sk from './locales/sk.json';
import da from './locales/da.json';
import sv from './locales/sv.json';
import fi from './locales/fi.json';
import el from './locales/el.json';
import hu from './locales/hu.json';
import ro from './locales/ro.json';
import bg from './locales/bg.json';
import et from './locales/et.json';
import lv from './locales/lv.json';
import lt from './locales/lt.json';
import sl from './locales/sl.json';
import nb from './locales/nb.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      de: { translation: de },
      en: { translation: en },
      fr: { translation: fr },
      es: { translation: es },
      it: { translation: it },
      pt: { translation: pt },
      nl: { translation: nl },
      pl: { translation: pl },
      cs: { translation: cs },
      sk: { translation: sk },
      da: { translation: da },
      sv: { translation: sv },
      fi: { translation: fi },
      el: { translation: el },
      hu: { translation: hu },
      ro: { translation: ro },
      bg: { translation: bg },
      et: { translation: et },
      lv: { translation: lv },
      lt: { translation: lt },
      sl: { translation: sl },
      nb: { translation: nb },
    },
    fallbackLng: 'de',
    // Collapse regional locale tags to the base code (e.g. "de-DE" -> "de").
    // Without this, i18n.language is the browser's full tag, which gets sent on
    // registration and violates the users.language_preference CHECK constraint
    // (Sentry GOE-RETURNS-BACKEND-K4 / "Database error saving new user").
    load: 'languageOnly',
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'goreturn-language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
